import { gql } from '@apollo/client';

import REFUND_METHODS_PAYMENT from './REFUND_METHODS_PAYMENT';

export default gql`
  query booking($reference: String!, $currency: Currency) {
    booking(reference: $reference) {
      additionalDetails {
        value
        key
        itemRef
      }
      reference
      status
      totalPriceToBePaid: totalPriceToBePaidWithCurrency(currency: $currency)
      customer {
        email
        firstName
        lastName
      }
      notes {
        uuid
        content
        author
        createdAt
      }
      refunds @client {
        ...RefundMethodsPayment
      }
      payments {
        ...RefundMethodsPayment
      }
      isPackage
      hotels {
        itemRef
      }
    }
  }

  ${REFUND_METHODS_PAYMENT}
`;
